import Vue from 'vue'
import Router from '@/router'
import UnauthorizedError from '@/plugins/sdk/Errors/RequestError/UnauthorizedError'
import ForbiddenError from '@/plugins/sdk/Errors/RequestError/ForbiddenError'
import BadRequestError from '@/plugins/sdk/Errors/RequestError/BadRequestError'
import NotFoundError from '@/plugins/sdk/Errors/RequestError/NotFoundError'
import MethodNotAllowedError from '@/plugins/sdk/Errors/RequestError/MethodNotAllowedError'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { Notification } from 'element-ui'

export default {
  install (Vue) {
    Vue.config.errorHandler = handleError

    window.addEventListener('unhandledrejection', function (e) {
      Vue.config.errorHandler(e.reason)
    })

    if (process.env.NODE_ENV !== 'development') {
      Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        integrations: [
          new Integrations.Vue({
            Vue,
            attachProps: true
          })
        ]
      })
    }
  }
}

function handleError (error) {
  const vm = new Vue()
  if (error instanceof UnauthorizedError) {
    if (Router.currentRoute.name !== 'authentication-signin' && Router.currentRoute.name !== 'authentication-resetpassword') {
      vm.$message.error('Your session has expired, please sign in again')
      Router.push({ name: 'authentication-signin', query: { expired: true, email: vm.$user.email } })
    }
  } else if (error instanceof ForbiddenError) {
    vm.$message.error('You do not have permission to execute this action')
  } else if (error instanceof BadRequestError) {
    parseBadRequestResponse(error.resource).forEach(message => {
      // eslint-disable-next-line
      Notification({
        title: 'Bad Request',
        message: message,
        type: 'error',
        duration: 0
      })
    })
    vm.$message.warning('Please check your data and try again')
  } else if (error instanceof NotFoundError) {
    vm.$message.error(`The resource you are requesting is not found: [${error.resource.name || 'resource'}]`)
  } else if (error instanceof MethodNotAllowedError) {
    vm.$message.error('The request method is not allowed')
  } else {
    console.error(error)
    vm.$message.error('An error has occurred while processing your request')
  }
}

function parseBadRequestResponse (resource) {
  let messages = []
  for (const [key] of Object.entries(resource.$fields)) {
    if (resource.$fields[key].messages.length) {
      resource.$fields[key].messages.forEach(element => {
        messages.push(element)
      })
    }
  }
  return messages
}
